import { openCheckPointsModalStore } from 'src/modules/Distances/components/shared/Steps/GPX/stores';

export const openModal = () => {
  openCheckPointsModalStore.on();
};
